import { useDispatch } from "react-redux";
import { setShowLogIn } from "../app/Slices/Ui";
import GoogleButton from "./GoogleButton";
import Input from "./Input";

function Signup() {
  const dispatch = useDispatch();
  return (
    <div className="flex flex-col justify-center items-center">
      <h1 className="font-semibold	text-4xl mb-3.5	">Sign Up</h1>
      <p className="text-2xl text-center	font-normal mb-2	">
        Join the Generative-Creator
        <br />
        Community today
      </p>
      <GoogleButton text="Sign up with Google" />
      <Input type="email" placeholder="email" />
      <Input type="password" placeholder="password" />
      <button className="py-6 max-w-[307px] w-full font-bold text-2xl	 px-16 lg:px-28 text-white rounded bg-blue rounded-[23px]">
        Log in
      </button>
      <p className="text-blue text-center my-3">
        Already Have an account?
        <br />
        <span
          onClick={() => dispatch(setShowLogIn(true))}
          className="underline cursor-pointer"
        >
          Login
        </span>
      </p>
    </div>
  );
}

export default Signup;
